<script>
  import { format } from 'svelte-i18n';

  import { Clipboard } from '@client/components/clipboard';
  import { Icon } from '@client/components/icon';

  export let label;
  export let source;

  let copying = false;

  const copyText = (copyFn) => {
    copying = true;
    copyFn(source);

    setTimeout(() => {
      copying = false;
    }, 1000);
  };
</script>

<div class="text" class:copying>
  <Clipboard text={source} let:copy>
    <div role="button" tabindex="0" on:click|preventDefault={() => copyText(copy)}>
      {#if copying}
        <Icon name="check" />
      {:else}
        <Icon name="copy" />
      {/if}

      {#if copying}
        {$format('label.COPIED')}
      {:else}
        {label}
      {/if}
    </div>
  </Clipboard>
</div>

<style lang="scss" src="./copy-text.scss"></style>
